import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { EduBlogService } from 'src/app/service/context/edu/edu-blog.service';
import { RemoveUnicode } from 'src/app/admin/shared/ultils';

@Component({
    selector: 'app-edu-blog-edit',
    templateUrl: './edu-blog-edit.component.html',
    styles: []
})
export class EduBlogEditComponent implements OnInit {
    constructor(
        private eduBlogService: EduBlogService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    // Cơ bản
    host: string;
    guid: string;
    eduBlog: any = {
        isActive: 0,
    };
    editorConfig: AngularEditorConfig = {};

    ngOnInit() {
        // Cơ bản
        this.editorConfig = {
            editable: true,
            spellcheck: true,
            height: '200px',
            minHeight: '0',
            maxHeight: 'auto',
            width: 'auto',
            minWidth: '0',
            translate: 'yes',
            enableToolbar: true,
            showToolbar: true,
            placeholder: 'Nhập nội dung...',
            defaultParagraphSeparator: '',
            defaultFontName: '',
            defaultFontSize: '',
            fonts: [
                { class: 'arial', name: 'Arial' },
                { class: 'times-new-roman', name: 'Times New Roman' },
                { class: 'calibri', name: 'Calibri' },
                { class: 'comic-sans-ms', name: 'Comic Sans MS' }
            ],
            customClasses: [
                {
                    name: 'quote',
                    class: 'quote',
                },
                {
                    name: 'redText',
                    class: 'redText'
                },
                {
                    name: 'titleText',
                    class: 'titleText',
                    tag: 'h1',
                },
            ],
            sanitize: false,
            toolbarPosition: 'top'
        };
        this.guid = this.route.snapshot.paramMap.get('guid');
        this.host = this.eduBlogService.BaseHost;

        if (this.guid)
            this.loadData();
    }

    loadData() {
        this.eduBlogService.getEduBlogById(this.guid).subscribe(
            res => {
                if (!res)
                    this.router.navigateByUrl('/techbyte/admin/error');

                this.eduBlog = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onSave() {
        this.eduBlog.seoFriendUrl = RemoveUnicode(this.eduBlog.title);
        document.getElementById('page-loader-data').style.display = "block";
        this.eduBlogService.saveEduBlog(this.eduBlog).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.router.navigateByUrl('/techbyte/admin/edu-blog');
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onCancel() {
        this.router.navigateByUrl('/techbyte/admin/edu-blog');
    }

    uploadFeatureImage = (files) => {
        if (files.length === 0) {
            return;
        }

        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);

        this.toastr.info("Đang tải lên...");
        var forms = document.getElementsByClassName("tile");
        for (var i = 0; i < forms.length; i++) {
            forms[i].classList.add('refreshing');
        }
        document.querySelectorAll('.tile button').forEach(elem => {
            (<any>elem).disabled = true;
        });
        document.querySelectorAll('.tile a').forEach(elem => {
            (<any>elem).style.display = 'none';
        });
        document.getElementById('page-loader-data').style.display = "block";
        this.eduBlogService.uploadFeatureImage(formData).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.Response) {
                    if (event.body) {
                        this.toastr.clear();
                        this.toastr.success("Tải lên thành công !");

                        this.eduBlog.fileName = (<any>event.body).fileName;
                        this.eduBlog.featureImage = (<any>event.body).path;

                        for (var i = 0; i < forms.length; i++) {
                            forms[i].classList.remove('refreshing');
                        }
                        document.querySelectorAll('.tile button').forEach(elem => {
                            (<any>elem).disabled = false;
                        });
                        document.querySelectorAll('.tile a').forEach(elem => {
                            (<any>elem).style.display = 'block';
                        });
                        document.getElementById('page-loader-data').style.display = "none";
                    }
                }
            },
            error: (err: HttpErrorResponse) => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');

                for (var i = 0; i < forms.length; i++) {
                    forms[i].classList.remove('refreshing');
                }
                document.querySelectorAll('.tile button').forEach(elem => {
                    (<any>elem).disabled = false;
                });
                document.querySelectorAll('.tile a').forEach(elem => {
                    (<any>elem).style.display = 'block';
                });
                document.getElementById('page-loader-data').style.display = "none";
            }
        });
    }
}